import styled from 'styled-components/macro'
import { Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'

export const StakeCol = styled(Col)`
  margin-bottom: 30px;
`
export const StakeWrapper = styled.div`
  border-radius: 10px;
  background-color: #fff;
  padding: 1.5rem;
  text-align: center;
  color: #fff;
`
export const Icons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 0.5rem;
  background: #154ba0;
  margin: 0 auto;
`
export const Icon = styled.img`
  width: 40px;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
`
export const StakeTitle = styled.h5`
  margin-top: 1.5rem;
  font-size: 24px;
  color: #154ba0;
`
export const StakeSubTitle = styled.p`
  margin-top: 1rem;
  font-size: 13px;
  font-weight: 400;
  text-align: center;
  color: #727eaa;
`
export const StakeLink = styled(Link)`
  display: block;
  margin-top: 2rem;
  background-color: #154ba0;
  padding: 0.75rem 1rem;
  text-align: center;
  text-transform: uppercase;
  line-height: 1rem;
  border-radius: 2rem;
  font-size: 13px;
  font-weight: 600;
  color: #fff;

  &:hover,
  &:focus,
  &:active {
    background-color: #154ba0;
    color: #fff;
    text-decoration: none;
  }
`
export const StakeFooter = styled.div`
  margin-top: 2rem;
  width: 100%;
  line-height: 32px;
  font-size: 14px;
  text-align: center;
  color: #727eaa;
`
export const StakeFooterItem = styled.div`
  display: flex;
  justify-content: space-between;
`
export const WithdrawCountdown = styled.span`
  display: block;
  width: 100%;
  border: 1px solid #e2007a;
  color: #e2007a;
  pointer-events: none;
  padding: 0.75rem 1rem;
  text-align: center;
  letter-spacing: 2px;
  line-height: 1rem;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
`
